// Single source of truth for garage / ride vehicle types.
// Stable ids — must match backend VEHICLE_TYPES in routes/garage.py.
export const VEHICLE_TYPES = [
    { id: 'ebike', label: 'eBike' },
    { id: 'bicycle', label: 'Bicycle' },
    { id: 'mtb', label: 'Mountain Bike (MTB)' },
    { id: 'escooter', label: 'Electric Scooter' },
    { id: 'scooter', label: 'Kick Scooter' },
    { id: 'skateboard', label: 'Skateboard' },
    { id: 'electric_skateboard', label: 'Electric Skateboard' },
    { id: 'onewheel', label: 'Onewheel' },
    { id: 'euc', label: 'Electric Unicycle (EUC)' },
    { id: 'dirt_bike', label: 'Dirt Bike (gas)' },
    { id: 'dirtbike', label: 'Dirtbike' },
    { id: 'electric_dirt_bike', label: 'Electric Dirt Bike' },
    { id: 'emoto', label: 'eMoto' },
    { id: 'quad', label: 'Quad / ATV' },
    { id: 'kart', label: 'Kart' },
    { id: 'wheelchair', label: 'Wheelchair (adaptive / powerchair)' },
    { id: 'diy_conversion', label: 'DIY Build / Conversion' },
    { id: 'paddleboard', label: 'Paddleboard' },
    { id: 'foilboard', label: 'Foilboard / e-Foil' },
    { id: 'custom', label: 'Custom' },
];

export const VEHICLE_LABELS = VEHICLE_TYPES.reduce((a, v) => { a[v.id] = v.label; return a; }, {});
export const vehicleLabel = (id) => VEHICLE_LABELS[id] || String(id || '').replace(/_/g, ' ');
export default VEHICLE_TYPES;
